enum ActionTypes {
  IDENTITY_GET = 'Identity/GET',
  IDENTITY_GET_SUCCESS = 'Identity/GET_SUCCESS',
  IDENTITY_GET_FAILURE = 'Identity/GET_FAILURE',
}

export default ActionTypes;
